import PropTypes from 'prop-types'
import { FormControl } from '@material-ui/core'

import { Colors } from '~/styles'
import { Button, Input, InputSelect, InputDateTimeKendo } from '~/components'

import ListDocument from '../list-document'
import Styled from '../../generate-sr-modal.styled'

const FormContent = ({ data, methods }) => {
  return (
    <div id='mdl_vessel_forecast_generate_sr_dialog_content' style={{ padding: '24px' }}>
      <form id='vessel_forecast_generate_sr_form'>
        <Styled.FormContainer gridTemplateColumns='1fr 1fr'>
          <div>
            <Styled.Label>Service Request No.</Styled.Label>
            <Input
              id='vessel_forecast_generate_sr_sr_no_input'
              type='text'
              name='sr_no'
              form={data.form}
              variant='outlined'
              disable={true}
              readOnly={true}
              placeholder='SRXXXXXXXXX'
            />
          </div>
          <div>
            <Styled.Label>SR Model <span>*</span></Styled.Label>
            <FormControl variant='outlined' style={{ width: '100%' }}>
              <InputSelect
                id='vessel_forecast_generate_sr_sr_model_input'
                name='sr_model_code'
                form={data.form}
                value={data.listServiceRequestModel.find((e) => e['value'] === data.form.values.sr_model_code)}
                variant='outlined'
                options={data.listServiceRequestModel}
                optionText='label'
                optionValueKey='value'
                onChange={(_, val) => methods.handleChangeDropdown('sr_model_code', val)}
              />
            </FormControl>
          </div>
        </Styled.FormContainer>
        <Styled.FormContainer>
          <Styled.Label>Client Name <span>*</span></Styled.Label>
          <Input
            id='vessel_forecast_generate_sr_client_name_input'
            type='text'
            name='customer_name'
            form={data.form}
            variant='outlined'
            disable={true}
            readOnly={true}
            placeholder='Client Name'
          />
        </Styled.FormContainer>
        <Styled.FormContainer gridTemplateColumns='1fr 1fr'>
          <div>
            <Styled.Label>Location <span>*</span></Styled.Label>
            <Input
              id='vessel_forecast_generate_sr_location_input'
              type='text'
              name='location'
              form={data.form}
              variant='outlined'
              disable={true}
              readOnly={true}
              placeholder='Location'
            />
          </div>
          <div>
            <Styled.Label>Priority Request <span>*</span></Styled.Label>
            <FormControl variant='outlined' style={{ width: '100%' }}>
              <InputSelect
                id='vessel_forecast_generate_sr_priority_request_input'
                name='priority_code'
                form={data.form}
                value={data.listPriorityRequest.find((e) => e['value'] === data.form.values.priority_code)}
                variant='outlined'
                options={data.listPriorityRequest}
                optionText='label'
                optionValueKey='value'
                onChange={(_, val) => methods.handleChangeDropdown('priority_code', val)}
              />
            </FormControl>
          </div>
        </Styled.FormContainer>

        <Styled.FormContainer gridTemplateColumns='1fr 1fr'>
          <div>
            <Styled.Label>Laycan Start Date <span>*</span></Styled.Label>
            <InputDateTimeKendo
              id='vessel_forecast_generate_sr_estimation_start_date_input'
              tabIndex={10}
              form={data.form}
              name='estimation_start_date'
              placeholder='Laycan Start Date'
            />
          </div>
          <div>
            <Styled.Label>Laycan Finish Date <span>*</span></Styled.Label>
            <InputDateTimeKendo
              id='vessel_forecast_generate_sr_estimation_finish_date_input'
              form={data.form}
              name='estimation_finish_date'
              tabIndex={10}
              placeholder='Laycan Finish Date'
            />
          </div>
        </Styled.FormContainer>

        <Styled.FormContainer>
          <Styled.Label>Request Descrtiption <span>*</span></Styled.Label>
          <Input
            id='vessel_forecast_generate_sr_request_description_input'
            rows={4}
            type='text'
            name='remarks'
            form={data.form}
            variant='outlined'
            multiline={true}
            placeholder='Request Descrtiption'
          />
        </Styled.FormContainer>

        <Styled.FormContainer>
          <Styled.Label>Document</Styled.Label>
          <Styled.UploadContainer>
            <input
              hidden
              multiple
              ref={data.ref}
              type='file'
              id='upload_file'
              name='upload_file'
              onChange={methods.handleUpload}
              accept='application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.etsi.pstn+xml, image/jpg, image/jpeg, image/png'
            />
            <ListDocument
              data={data.attachments.filter(item => !item.is_deleted)}
              srNo={data.form.values.sr_no}
              hasTime={true}
              isDelete={true}
              isUpload={data.isUploading}
              fullWidth={true}
              onClickUpload={methods.triggerUpload}
              onClickDelete={methods.removeAttachment}
              isDownloadAll={data.attachments.filter(item => !item.is_deleted).length > 0}
            />
          </Styled.UploadContainer>
        </Styled.FormContainer>

        <Styled.ActionContainer>
          <Button
            id='vessel_forecast_generate_sr_estimation_start_draft_button'
            type='button'
            color='transparent'
            style={{ border: `1px solid ${Colors.grey}` }}
            onClick={() => methods.handleSubmit('draft')}
          >
            Draft
          </Button>
          <Button
            id='vessel_forecast_generate_sr_estimation_start_submit_button'
            type='button'
            color='blue'
            onClick={() => methods.handleSubmit('confirm')}
          >
            Submit
          </Button>
        </Styled.ActionContainer>
      </form>
    </div>
  )
}

FormContent.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    isUploading: PropTypes.bool.isRequired,
    attachments: PropTypes.array.isRequired,
    listPriorityRequest: PropTypes.array.isRequired,
    listServiceRequestModel: PropTypes.array.isRequired,
  }).isRequired,
  methods: PropTypes.shape({
    handleSubmit: PropTypes.func.isRequired,
    handleUpload: PropTypes.func.isRequired,
    triggerUpload: PropTypes.func.isRequired,
    removeAttachment: PropTypes.func.isRequired,
    handleChangeDropdown: PropTypes.func.isRequired,
  }).isRequired
}

export default FormContent